<div class="container">
  <div class="row">
    <div class="col col-12">
      <div class="account-select">
        <div class="section title">
          <span class="text-subtle-gray_1000">{{
            'checkout.account.title' | transloco
          }}</span>
        </div>
        <div class="section select">
          <div class="group">
            <span class="group_label">
              {{ 'checkout.account.myBoels' | transloco }}
            </span>
            <button
              boelsButton
              (click)="checkoutRequestLogin()"
              [icon]="faLoginIcon"
              variant="primary-brand"
            >
              {{ 'checkout.account.login' | transloco }}
            </button>
            <div class="disclaimer">
              <span class="text-subtle-gray_1000">
                {{ 'checkout.account.disclaimer' | transloco }}
              </span>
            </div>
          </div>
          <div class="divider">
            <div class="divider_line"></div>
          </div>
          <div class="group">
            <span class="group_label">
              {{ 'checkout.account.guest' | transloco }}
            </span>
            <button boelsButton variant="secondary" (click)="checkoutAsGuest()">
              {{ 'checkout.account.continue' | transloco }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
